var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ 'font-family': _vm.fontFamily }),attrs:{"id":"app"}},[_c('app-header'),_c('router-view',{staticStyle:{"backgroundColor":"#fbfbf9","min-height":"92vh"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }